import '../styles.css';
// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  const handleResetCookies = () => {
    localStorage.removeItem('gamepulse_consent');
    window.location.reload();
  };

  return (
    <footer className="footer-main">
      <div className="footer-content">
        <p>© 2026 <span className="text-highlight">GamePulse HQ</span></p>

        <nav className="footer-nav">
          <button 
            onClick={handleResetCookies} 
            className="footer-cookie-btn"
            style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: '12px' }}
          >
            Préférences Cookies
          </button>

          <Link to="/privacy-policy" className="footer-link">
            Politique de Confidentialité
          </Link>

          <Link to="/contact" className="footer-link">
            Contact
          </Link>

          <Link to="/legal" className="footer-link">
            Mentions Légales
          </Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;